package one.healthium.bland.presentation.navigation.today

import androidx.compose.runtime.Composable
import one.healthium.bland.presentation.feature.today.TodayScreen

@Composable
fun TodayContent(
    component: TodayComponent,
) {
    TodayScreen(component)
}